import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import devtools from '@/plugins/devtools';
import { OnCtrlMetaEnter } from '@/plugins/directive-on-ctrl-meta-enter';
import { Uppercase } from '@/plugins/directive-uppercase';
import { IsOverflowing } from '@/plugins/directive-overflow';
import { vHover } from '@/plugins/directive-hover';
import { vuetify } from './plugins/vuetify';
import { i18n } from './localization';
import PortalVue from 'portal-vue';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore: Unreachable code error
import { createPinia } from 'pinia';
import { UnheadPlugin } from '@unhead/vue/vue2';
import { vEllipsis } from '@/plugins/directive-ellipsis';
import { createAuth0 } from '@auth0/auth0-vue';

const app = createApp(App);
const pinia = createPinia();

app.use(
  createAuth0({
    domain: window.__env.VUE_APP_AUTH0_DOMAIN,
    clientId: window.__env.VUE_APP_AUTH0_CLIENT_ID,
    authorizationParams: {
      redirect_uri: window.location.origin,
      audience: window.__env.VUE_APP_AUTH0_AUDIENCE,
      scope: 'openid profile email offline_access read:data',
    },
    cacheLocation: 'localstorage',
    useRefreshTokensFallback: true,
    useRefreshTokens: true,
  })
);

app.use(router);
app.use(store);
app.use(pinia);
app.use(UnheadPlugin);
app.use(devtools);
app.use(i18n);
app.use(vuetify);
app.use(PortalVue, {
  portalName: false,
  portalTargetName: false,
});

app.config.performance = true;

app.directive('on-ctrl-meta-enter', OnCtrlMetaEnter);
app.directive('uppercase', Uppercase);
app.directive('is-overflowing', IsOverflowing);
app.directive('hover', vHover);
app.directive('ellipsis', vEllipsis);

if (
  window.__env === undefined ||
  (import.meta.env.PROD && !window.__env.production)
) {
  alert('Configuration error!');
} else {
  app.mount('#app');
}
